unit FMSFuelSystemSetup;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Controls, WEBLib.ExtCtrls, Vcl.StdCtrls,
  WEBLib.StdCtrls, Data.DB, WEBLib.DB, XData.Web.JsonDataset, XData.Web.Dataset,
  XData.Web.Client, WEBLib.DBCtrls;

type
  TfrmFMSFuelSystem = class(TForm)
    WebPanel1: TPanel;
    WebPanel2: TPanel;
    WebPanel3: TPanel;
    WebButton1: TButton;
    WebButton2: TButton;
    WebLabel1: TLabel;
    WebLabel2: TLabel;
    WebLabel3: TLabel;
    WebButton3: TButton;
    wcFMSFuelSystem: TXDataWebClient;
    wdsFMSFuelSystem: TXDataWebDataSet;
    dsFMSFuelSystem: TDataSource;
    wdsFMSFuelSystemApiServerNo: TIntegerField;
    wdsFMSFuelSystemSubContractNo: TStringField;
    wdsFMSFuelSystemApiAccountNo: TStringField;
    wdsFMSFuelSystemLastRunDate: TDateField;
    wdsFMSFuelSystemSubsRegNo: TStringField;
    wdsFMSFuelSystemCRName: TStringField;
    edtSubContractor: TDBEdit;
    WebDBEdit2: TDBEdit;
    WebDBEdit3: TDBEdit;
    procedure WebFormShow(Sender: TObject);
    procedure WebButton3Click(Sender: TObject);
    procedure WebButton2Click(Sender: TObject);
    procedure WebButton1Click(Sender: TObject);
  private
    { Private declarations }
  public
    { Public declarations }
    sCompany, sSubcontractorno : String;
    iState, iApiserverno : Integer;
  protected procedure LoadDFMValues; override; end;

var
  frmFMSFuelSystem: TfrmFMSFuelSystem;

implementation

{$R *.dfm}

  uses
    stfmssystem.connection , share.system.classes , share.common,
    search.subs;

procedure TfrmFMSFuelSystem.WebButton1Click(Sender: TObject);
  procedure OnSuccess(Response : TXDataClientResponse);
    begin
      wdsFMSFuelSystem.Cancel;
      Close;
    end;
  procedure OnError(Error: TXDataClientError);
    begin
      ShowMessage(Error.ErrorMessage);
      Close;
    end;

begin

  wdsFMSFuelSystem.FieldByName('apiserverno').AsInteger := 2;

  case iState of
    1 : Begin
          console.log(GetJsonFromDataSet(wdsFMSFuelSystem));
          wcFMSFuelSystem.RawInvoke('IstfmsSystemService.Put_TFNSubAccountsS1_Insert',[GetJsonFromDataSet(wdsFMSFuelSystem)],@OnSuccess, @OnError);
        End;
    2 : Begin
          wcFMSFuelSystem.RawInvoke('IstfmsSystemService.Put_TFNSubAccountsS1_Edit',[sSubcontractorno,GetJsonFromDataSet(wdsFMSFuelSystem)],@OnSuccess, @OnError);
        End;
  end;
end;

procedure TfrmFMSFuelSystem.WebButton2Click(Sender: TObject);
begin
  Close;
end;

procedure TfrmFMSFuelSystem.WebButton3Click(Sender: TObject);
  var
    LFrm : TfrmSearchSubs;

  procedure AfterShowModal(AValue: TModalResult);
  begin
    with LFrm do
      begin
        if sCode <> '' then
          begin
            edtSubContractor.Text := sCode;
            sCompany := sCode;
            wdsFMSFuelSystem.FieldByName('SubContractNo').AsString := sCode;
          end
        else
          begin
            edtSubContractor.Text := '';
            sCompany := '';
            wdsFMSFuelSystem.FieldByName('SubContractNo').AsString := '';
          end;
      end;
  end;

  procedure AfterCreate(AForm : TObject);
  begin
    with (AForm as TfrmSearchSubs) do
      begin
        bSuspended := True;
        iType := 0;
        GetData;

      end;
  end;
begin
  LFrm := TfrmSearchSubs.CreateNew( @AfterCreate );

  // LFrm als Pop-Up festlegen
  LFrm.Popup := true;

  // Transparenz definieren
  LFrm.PopupOpacity := 0.2;

  LFrm.ShowModal(@AfterShowModal);
end;

procedure TfrmFMSFuelSystem.WebFormShow(Sender: TObject);
  procedure OnResultFMSFuelSystem(Response : TXDataClientResponse);
    begin
      wdsFMSFuelSystem.Close;
      wdsFMSFuelSystem.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
      wdsFMSFuelSystem.Open;

      console.log(GetJsonFromDataSet(wdsFMSFuelSystem));

      if iState = 2 then
        Begin
          wdsFMSFuelSystem.Edit;
        End;

    end;
begin
  case iState of
    1 : Begin
          wdsFMSFuelSystem.Open;
          wdsFMSFuelSystem.Insert;
        End;

    2 : Begin
          wcFMSFuelSystem.RawInvoke('IstfmsSystemService.Get_TFNSubAccountsS1_View',[0,2,sSubcontractorno],@OnResultFMSFuelSystem);
        End;
  end;

end;

procedure TfrmFMSFuelSystem.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebPanel1 := TPanel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  WebLabel2 := TLabel.Create(Self);
  WebLabel3 := TLabel.Create(Self);
  WebPanel2 := TPanel.Create(Self);
  WebPanel3 := TPanel.Create(Self);
  WebButton1 := TButton.Create(Self);
  WebButton2 := TButton.Create(Self);
  WebButton3 := TButton.Create(Self);
  edtSubContractor := TDBEdit.Create(Self);
  WebDBEdit2 := TDBEdit.Create(Self);
  WebDBEdit3 := TDBEdit.Create(Self);
  wcFMSFuelSystem := TXDataWebClient.Create(Self);
  wdsFMSFuelSystem := TXDataWebDataSet.Create(Self);
  wdsFMSFuelSystemApiServerNo := TIntegerField.Create(Self);
  wdsFMSFuelSystemSubContractNo := TStringField.Create(Self);
  wdsFMSFuelSystemApiAccountNo := TStringField.Create(Self);
  wdsFMSFuelSystemLastRunDate := TDateField.Create(Self);
  wdsFMSFuelSystemSubsRegNo := TStringField.Create(Self);
  wdsFMSFuelSystemCRName := TStringField.Create(Self);
  dsFMSFuelSystem := TDataSource.Create(Self);

  WebPanel1.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  WebLabel3.BeforeLoadDFMValues;
  WebPanel2.BeforeLoadDFMValues;
  WebPanel3.BeforeLoadDFMValues;
  WebButton1.BeforeLoadDFMValues;
  WebButton2.BeforeLoadDFMValues;
  WebButton3.BeforeLoadDFMValues;
  edtSubContractor.BeforeLoadDFMValues;
  WebDBEdit2.BeforeLoadDFMValues;
  WebDBEdit3.BeforeLoadDFMValues;
  wcFMSFuelSystem.BeforeLoadDFMValues;
  wdsFMSFuelSystem.BeforeLoadDFMValues;
  wdsFMSFuelSystemApiServerNo.BeforeLoadDFMValues;
  wdsFMSFuelSystemSubContractNo.BeforeLoadDFMValues;
  wdsFMSFuelSystemApiAccountNo.BeforeLoadDFMValues;
  wdsFMSFuelSystemLastRunDate.BeforeLoadDFMValues;
  wdsFMSFuelSystemSubsRegNo.BeforeLoadDFMValues;
  wdsFMSFuelSystemCRName.BeforeLoadDFMValues;
  dsFMSFuelSystem.BeforeLoadDFMValues;
  try
    Name := 'frmFMSFuelSystem';
    Width := 568;
    Height := 347;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 0;
    WebPanel1.Width := 568;
    WebPanel1.Height := 347;
    WebPanel1.Align := alClient;
    WebPanel1.TabOrder := 0;
    WebLabel1.SetParentComponent(WebPanel1);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 88;
    WebLabel1.Top := 120;
    WebLabel1.Width := 46;
    WebLabel1.Height := 15;
    WebLabel1.Caption := 'Supplier:';
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.WidthPercent := 100.000000000000000000;
    WebLabel2.SetParentComponent(WebPanel1);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 88;
    WebLabel2.Top := 171;
    WebLabel2.Width := 64;
    WebLabel2.Height := 15;
    WebLabel2.Caption := 'AccountNo:';
    WebLabel2.HeightPercent := 100.000000000000000000;
    WebLabel2.WidthPercent := 100.000000000000000000;
    WebLabel3.SetParentComponent(WebPanel1);
    WebLabel3.Name := 'WebLabel3';
    WebLabel3.Left := 88;
    WebLabel3.Top := 211;
    WebLabel3.Width := 61;
    WebLabel3.Height := 15;
    WebLabel3.Caption := 'RegNoSubs';
    WebLabel3.HeightPercent := 100.000000000000000000;
    WebLabel3.WidthPercent := 100.000000000000000000;
    WebPanel2.SetParentComponent(WebPanel1);
    WebPanel2.Name := 'WebPanel2';
    WebPanel2.Left := 0;
    WebPanel2.Top := 0;
    WebPanel2.Width := 568;
    WebPanel2.Height := 60;
    WebPanel2.Align := alTop;
    WebPanel2.Caption := 'FMS Fuel System';
    WebPanel2.ChildOrder := 6;
    WebPanel2.Font.Charset := DEFAULT_CHARSET;
    WebPanel2.Font.Color := clWindowText;
    WebPanel2.Font.Height := -16;
    WebPanel2.Font.Name := 'Segoe UI';
    WebPanel2.Font.Style := [fsBold];
    WebPanel2.ParentFont := False;
    WebPanel2.TabOrder := 0;
    WebPanel3.SetParentComponent(WebPanel1);
    WebPanel3.Name := 'WebPanel3';
    WebPanel3.Left := 0;
    WebPanel3.Top := 287;
    WebPanel3.Width := 568;
    WebPanel3.Height := 60;
    WebPanel3.Align := alBottom;
    WebPanel3.ChildOrder := 7;
    WebPanel3.TabOrder := 1;
    WebButton1.SetParentComponent(WebPanel3);
    WebButton1.Name := 'WebButton1';
    WebButton1.Left := 22;
    WebButton1.Top := 18;
    WebButton1.Width := 96;
    WebButton1.Height := 25;
    WebButton1.Caption := 'Save';
    WebButton1.Color := clYellowgreen;
    WebButton1.HeightPercent := 100.000000000000000000;
    WebButton1.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton1, Self, 'OnClick', 'WebButton1Click');
    WebButton2.SetParentComponent(WebPanel3);
    WebButton2.Name := 'WebButton2';
    WebButton2.Left := 445;
    WebButton2.Top := 18;
    WebButton2.Width := 96;
    WebButton2.Height := 25;
    WebButton2.Caption := 'Cancel';
    WebButton2.Color := clRed;
    WebButton2.ChildOrder := 1;
    WebButton2.HeightPercent := 100.000000000000000000;
    WebButton2.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton2, Self, 'OnClick', 'WebButton2Click');
    WebButton3.SetParentComponent(WebPanel1);
    WebButton3.Name := 'WebButton3';
    WebButton3.Left := 383;
    WebButton3.Top := 119;
    WebButton3.Width := 25;
    WebButton3.Height := 25;
    WebButton3.Caption := '...';
    WebButton3.ChildOrder := 8;
    WebButton3.HeightPercent := 100.000000000000000000;
    WebButton3.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton3, Self, 'OnClick', 'WebButton3Click');
    edtSubContractor.SetParentComponent(WebPanel1);
    edtSubContractor.Name := 'edtSubContractor';
    edtSubContractor.Left := 200;
    edtSubContractor.Top := 120;
    edtSubContractor.Width := 177;
    edtSubContractor.Height := 22;
    edtSubContractor.ChildOrder := 6;
    edtSubContractor.HeightPercent := 100.000000000000000000;
    edtSubContractor.WidthPercent := 100.000000000000000000;
    edtSubContractor.DataField := 'SubContractNo';
    edtSubContractor.DataSource := dsFMSFuelSystem;
    WebDBEdit2.SetParentComponent(WebPanel1);
    WebDBEdit2.Name := 'WebDBEdit2';
    WebDBEdit2.Left := 200;
    WebDBEdit2.Top := 160;
    WebDBEdit2.Width := 153;
    WebDBEdit2.Height := 22;
    WebDBEdit2.ChildOrder := 7;
    WebDBEdit2.HeightPercent := 100.000000000000000000;
    WebDBEdit2.WidthPercent := 100.000000000000000000;
    WebDBEdit2.DataField := 'ApiAccountNo';
    WebDBEdit2.DataSource := dsFMSFuelSystem;
    WebDBEdit3.SetParentComponent(WebPanel1);
    WebDBEdit3.Name := 'WebDBEdit3';
    WebDBEdit3.Left := 200;
    WebDBEdit3.Top := 208;
    WebDBEdit3.Width := 121;
    WebDBEdit3.Height := 22;
    WebDBEdit3.ChildOrder := 8;
    WebDBEdit3.HeightPercent := 100.000000000000000000;
    WebDBEdit3.MaxLength := 2;
    WebDBEdit3.WidthPercent := 100.000000000000000000;
    WebDBEdit3.DataField := 'SubsRegNo';
    WebDBEdit3.DataSource := dsFMSFuelSystem;
    wcFMSFuelSystem.SetParentComponent(Self);
    wcFMSFuelSystem.Name := 'wcFMSFuelSystem';
    wcFMSFuelSystem.Connection := dmData.dbConnect;
    wcFMSFuelSystem.Left := 64;
    wcFMSFuelSystem.Top := 56;
    wdsFMSFuelSystem.SetParentComponent(Self);
    wdsFMSFuelSystem.Name := 'wdsFMSFuelSystem';
    wdsFMSFuelSystem.Connection := dmData.dbConnect;
    wdsFMSFuelSystem.Left := 160;
    wdsFMSFuelSystem.Top := 56;
    wdsFMSFuelSystemApiServerNo.SetParentComponent(wdsFMSFuelSystem);
    wdsFMSFuelSystemApiServerNo.Name := 'wdsFMSFuelSystemApiServerNo';
    wdsFMSFuelSystemApiServerNo.FieldName := 'ApiServerNo';
    wdsFMSFuelSystemSubContractNo.SetParentComponent(wdsFMSFuelSystem);
    wdsFMSFuelSystemSubContractNo.Name := 'wdsFMSFuelSystemSubContractNo';
    wdsFMSFuelSystemSubContractNo.FieldName := 'SubContractNo';
    wdsFMSFuelSystemApiAccountNo.SetParentComponent(wdsFMSFuelSystem);
    wdsFMSFuelSystemApiAccountNo.Name := 'wdsFMSFuelSystemApiAccountNo';
    wdsFMSFuelSystemApiAccountNo.FieldName := 'ApiAccountNo';
    wdsFMSFuelSystemLastRunDate.SetParentComponent(wdsFMSFuelSystem);
    wdsFMSFuelSystemLastRunDate.Name := 'wdsFMSFuelSystemLastRunDate';
    wdsFMSFuelSystemLastRunDate.FieldName := 'LastRunDate';
    wdsFMSFuelSystemSubsRegNo.SetParentComponent(wdsFMSFuelSystem);
    wdsFMSFuelSystemSubsRegNo.Name := 'wdsFMSFuelSystemSubsRegNo';
    wdsFMSFuelSystemSubsRegNo.FieldName := 'SubsRegNo';
    wdsFMSFuelSystemCRName.SetParentComponent(wdsFMSFuelSystem);
    wdsFMSFuelSystemCRName.Name := 'wdsFMSFuelSystemCRName';
    wdsFMSFuelSystemCRName.FieldName := 'CRName';
    dsFMSFuelSystem.SetParentComponent(Self);
    dsFMSFuelSystem.Name := 'dsFMSFuelSystem';
    dsFMSFuelSystem.AutoEdit := False;
    dsFMSFuelSystem.DataSet := wdsFMSFuelSystem;
    dsFMSFuelSystem.Left := 256;
    dsFMSFuelSystem.Top := 56;
  finally
    WebPanel1.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    WebLabel3.AfterLoadDFMValues;
    WebPanel2.AfterLoadDFMValues;
    WebPanel3.AfterLoadDFMValues;
    WebButton1.AfterLoadDFMValues;
    WebButton2.AfterLoadDFMValues;
    WebButton3.AfterLoadDFMValues;
    edtSubContractor.AfterLoadDFMValues;
    WebDBEdit2.AfterLoadDFMValues;
    WebDBEdit3.AfterLoadDFMValues;
    wcFMSFuelSystem.AfterLoadDFMValues;
    wdsFMSFuelSystem.AfterLoadDFMValues;
    wdsFMSFuelSystemApiServerNo.AfterLoadDFMValues;
    wdsFMSFuelSystemSubContractNo.AfterLoadDFMValues;
    wdsFMSFuelSystemApiAccountNo.AfterLoadDFMValues;
    wdsFMSFuelSystemLastRunDate.AfterLoadDFMValues;
    wdsFMSFuelSystemSubsRegNo.AfterLoadDFMValues;
    wdsFMSFuelSystemCRName.AfterLoadDFMValues;
    dsFMSFuelSystem.AfterLoadDFMValues;
  end;
end;

end.
